import { useCookies } from 'react-cookie';
import { createContainer } from 'unstated-next';

const useGlobalState = () => {
  const cookieNames = [
    'username', 'password', 'accessToken',
    'refreshToken', 'tokenType',
    'userData',
  ];
  const [cookies, setCookieOri, removeCookie] = useCookies(cookieNames);

  const setCookies = (
    ...param: Parameters<typeof setCookieOri>
  ) => setCookieOri(param[0], param[1], {
    path: '/',
    maxAge: 86400, // 24 hours
  });

  const removeAllCookies = () => {
    cookieNames.forEach((cookieName) => {
      removeCookie(cookieName);
    });
  };

  return {
    cookies,
    setCookies,
    removeCookie,
    removeAllCookies,
  };
};

const GlobalStateContainer = createContainer(useGlobalState);

export default GlobalStateContainer;
